import React from 'react';
import {WorkbenchStateContext} from "./WorkbenchContext";
import InvalidLicenseAlert from "../license/InvalidLicenseAlert";
import AlertWarning from "../../common/alert/AlertWarning";

type ContentBlockerProps = {
  renderLicenseAlert?: boolean
  checkReadPermission?: boolean
  checkCreatePermission?: boolean
}

/**
 * A component that will not render the provided children if the license is invalid or not set at all.
 */
export default class ContentBlocker extends React.Component<ContentBlockerProps> {

  public static defaultProps = {
    renderLicenseAlert: true
  };

  static contextType = WorkbenchStateContext;

  private hasValidLicense(): boolean {
    return this.context.license && this.context.license.isValid;
  }

  private hasPermissions() {
    const securityContext = this.context.security;
    if (securityContext) {
      if (!securityContext.enabled) {
        return true;
      }
      if (this.props.checkReadPermission) {
        return this.context.canRead();
      }
      if (this.props.checkCreatePermission) {
        return this.context.canCreate();
      }
      return this.context.security.roles?.length > 0;
    }
    return true;
  }

  render() {
    const hasValidLicense = this.hasValidLicense();
    const hasPermissions = this.hasPermissions();

    if (hasValidLicense && hasPermissions) {
      return this.props.children;
    }

    const alerts = [];

    if (!hasValidLicense && this.props.renderLicenseAlert) {
      alerts.push(<InvalidLicenseAlert key="InvalidLicenseAlert" license={this.context.license}/>);
    }

    if (!hasPermissions) {
      alerts.push(<NoPermissionsAlert key="NoPermissionsAlert"/>);
    }

    return (
      <>
        {alerts}
      </>
    );
  }
}

function NoPermissionsAlert() {
  return (
    <AlertWarning className="NoPermissionsAlert">
      <p>
        Your access to the OTP Workbench is limited due to the assigned roles.
      </p>
    </AlertWarning>
  );
}
